import React, { Component } from 'react';

import { apiReadOneAsset } from '../../../../../utils/apis';

import { GlobalContext } from '../../../../../utils/globalprovider';
import { AppExport_ExportType } from '../../../../../utils/software';


class PreviewBase extends React.Component
{

    static contextType = GlobalContext;

constructor (props)
{
    super(props);

    this.state = {
        asset: null,
        datas: null,
    };

    this.apicallbackReadAsset = this.apicallbackReadAsset.bind(this)
}



componentDidMount()
{


    if (this.props.asid)
        apiReadOneAsset ({asid:this.props.asid}, this.apicallbackReadAsset)   

}                                                                                    
componentDidUpdate()
{
}

componentWillUnmount()
{

}

apicallbackReadAsset(datas)
{
    this.setState({asset: datas})

}

render(retour)
{

 

    return (<></>);

}

}
export default PreviewBase;

